"use client";

import { useState } from "react";
import Image from "next/image";
import Button from "../button/Button";
import VideoModal from "@/components/videoModel";

const points = [
  <>
    <b>On-the-Job Learning</b>: Access to structured internship opportunities
    through collaborations with leading organisations across sectors.
  </>,
  <>
    <b>Career Readiness Workshops</b>: Support through resume-building sessions, group discussions, and skill-development workshops designed to prepare students for recruitment processes
  </>,
  <>
    <b>Placement Fun Fest</b>:  A dedicated platform offering mock interviews and group discussions to help students identify strengths, build confidence, and make informed career choices.
  </>,
  <>
    <b>Campus Placement Drives</b>: Opportunities to participate in on-campus placement drives with reputed companies representing diverse industries and job roles.
  </>,
  <>  
   <b> Pre-Placement Talks </b>: Exposure to industry insights through interactive sessions led by HR professionals, founders, managers, and subject-matter experts prior to placement processes.
  </>
];

export default function MSUAdvantagesSection() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const videoUrl = "https://www.youtube.com/watch?v=jnGm6uezeDA"; // Replace with your actual video URL

  return (
    <section className="">
      <div className="page-container py-10 md:py-12">
        {/* Title Section (same structure you provided) */}
        <div className="w-full text-left mb-2 md:mb-4">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-2"
            style={{ fontFamily: "saans-bold" }}
          >
            Our Placement Ecosystem
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-black leading-relaxed w-full md:w-[80%] lg:w-[70%]">
            We provide on-the-job learning, career readiness, and industry
            engagement to support students through structured preparation and
            guided transition from education to employment.
          </p>
        </div>

        {/* Content Box */}
        <div className="border-2 border-sky-500">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left: Blue panel */}
            <div className="bg-[#0B6EA8] text-white p-6 sm:p-8 min-h-[400px]">
              <h3 className="font-semibold text-lg sm:text-xl mb-5">
                A Glimpse of What We Offer:
              </h3>

              <ul className="space-y-4">
                {points.map((text, idx) => (
                  <li key={idx} className="flex gap-3">
                    <span className="mt-1.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/15">
                      <span className="h-2 w-2 rounded-full bg-white" />
                    </span>
                    <p className="text-sm sm:text-[15px] leading-relaxed text-white/95">
                      {text}
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Video Thumbnail with Play Button */}
            <div
              className="relative min-h-[400px] lg:min-h-full cursor-pointer group"
              onClick={() => setIsVideoOpen(true)}
            >
              <Image
                src="https://cdn.msu.edu.in/advantages_89bcbae0cf.png"
                alt="MSU Advantages Video"
                fill
                priority
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="object-cover"
              />

              {/* Dark overlay on hover */}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-all duration-300" />

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16  bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-[#0B6EA8] ml-1"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="w-full flex bg-[#FFA201] py-5 px-4 md:px-7 mt-4">
          <Button
            text={"Apply Now"}
            link={"/application"}
            paragraph={
              "Browse all programmes by one of the globally top-ranked skill university"
            }
          />
        </div> */}
      </div>

      {/* Video Modal */}
      <VideoModal
        open={isVideoOpen}
        url={videoUrl}
        onClose={() => setIsVideoOpen(false)}
      />
    </section>
  );
}
